export enum FileType {
    EXCEL = 1,
    PDF = 2
}